module.exports = __webpack_public_path__ + "img/zhihuipengguan.d3785410.svg";